import { render, staticRenderFns } from "./ChucDanhNguoiKy.vue?vue&type=template&id=74495c1d&scoped=true&"
import script from "./ChucDanhNguoiKy.vue?vue&type=script&lang=js&"
export * from "./ChucDanhNguoiKy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74495c1d",
  null
  
)

export default component.exports